if (!customElements.get('soph-announcement')) {
  customElements.define('soph-announcement', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const button = this.querySelector('button');
      const viewport = this.querySelector('.soph-announcement__viewport');
      const group = this.querySelector('.soph-announcement__group');
      if (!button || !viewport || !group) return;

      this.controller = new AbortController();
      const { signal } = this.controller;
      const preference = matchMedia('(prefers-reduced-motion: reduce)');
      const updateMotion = () => {
        this.dataset.motion = preference.matches ? 'off' : 'on';
        button.hidden = preference.matches;
      };
      preference.addEventListener('change', updateMotion, { signal });
      button.addEventListener('click', () => {
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Resume announcements' : 'Pause announcements');
      }, { signal });

      this.observer = new ResizeObserver(() => {
        this.style.setProperty('--soph-announcement-width', `${viewport.clientWidth}px`);
        this.style.setProperty('--soph-announcement-duration', `${Math.max(12, group.getBoundingClientRect().width / 35)}s`);
      });
      updateMotion();
      this.observer.observe(viewport);
      this.observer.observe(group);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
      this.observer = null;
    }
  });
}
